import * as tslib_1 from "tslib";
import { BaseComponent } from "../../../../base/base.component";
import { ButtonsModel } from "../../../../../crossconcern/models/tablelist/button.model";
import { TableInfo } from "../../../../../crossconcern/models/tablelist/tableinfo.model";
import { AppComponent } from "../../../../app.component";
import { Router } from "@angular/router";
import { NurseryManager } from "../../../../../business/managers/nursery.manager";
import { TableInfoHeader } from "../../../../../crossconcern/models/tablelist/tableinfoheader.model";
import { Location } from "@angular/common";
import { TABLELIST_ITEMS_PER_PAGE } from "../../../../../crossconcern/utilities/properties/base.property";
import { TABLELIST_BUTTON_COLOR_4, TABLELIST_BUTTON_COLOR_5, TABLELIST_BUTTON_COLOR_8, TABLELIST_BUTTON_ICON_CLASS_CLONE, TABLELIST_BUTTON_ICON_CLASS_DELETE, TABLELIST_BUTTON_ICON_CLASS_VIEW } from "../../../../../crossconcern/utilities/properties/tablelist.property";
import { finalize } from "rxjs/operators";
import { AlertUtils } from "../../../../../crossconcern/utilities/utils/alert.utils";
import { PRIVATE_NURSERY_ADD_ROUTE, PRIVATE_NURSERY_DETAIL_ROUTE, PRIVATE_NURSERY_EDIT_ROUTE } from "../../../../../crossconcern/utilities/properties/routename.property";
import { PhotosphereManager } from "../../../../../business/managers/photosphere.manager";
import { GenericService } from "app/crossconcern/services/generic.services";
import { logData } from "../../../../../crossconcern/helpers/generic/generic.helper";
var NurseryListComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NurseryListComponent, _super);
    function NurseryListComponent(appComponent, router, location, nurseryManager, photosphereManager, genericService, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.nurseryManager = nurseryManager;
        _this.photosphereManager = photosphereManager;
        _this.genericService = genericService;
        _this.alertUtils = alertUtils;
        _this.currentPage = 0;
        _this.selectedFilters = new Map();
        _this.subscribeGenericServices();
        return _this;
    }
    NurseryListComponent.prototype.ngOnInit = function () {
        this.getNurseries();
    };
    NurseryListComponent.prototype.onViewDetailClick = function (index) {
        var nursery = this.nurseries[index];
        this.goToRouteByName(PRIVATE_NURSERY_DETAIL_ROUTE, { id: nursery.uuid });
    };
    NurseryListComponent.prototype.onEditClick = function (index) {
        var nursery = this.nurseries[index];
        this.goToRouteByName(PRIVATE_NURSERY_EDIT_ROUTE, { id: nursery.uuid });
    };
    NurseryListComponent.prototype.onDeleteClick = function (index) {
        var _this = this;
        var nursery = this.nurseries[index];
        this.alertUtils.showConfirmAlert("NURSERY_LIST_COMPONENT_DELETE_CONFIRM_TITLE_ALERT", "NURSERY_LIST_COMPONENT_DELETE_CONFIRM_TEXT_ALERT", function () {
            _this.appComponent.startLoading();
            _this.nurseryManager.deleteNursery(nursery.uuid)
                .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
                .subscribe(function () {
                _this.getNurseries();
            });
        }, function () {
            logData("close");
        });
    };
    NurseryListComponent.prototype.onCloneClick = function (index) {
        var _this = this;
        var nursery = this.nurseries[index];
        this.alertUtils.showConfirmAlert("NURSERY_LIST_COMPONENT_CLONE_CONFIRM_TITLE_ALERT", "NURSERY_LIST_COMPONENT_CLONE_CONFIRM_TEXT_ALERT", function () {
            _this.appComponent.startLoading();
            _this.nurseryManager.duplicateNursery(nursery.uuid)
                .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
                .subscribe(function () {
                _this.getNurseries();
            });
        }, function () {
            logData("close");
        });
    };
    NurseryListComponent.prototype.getNurseries = function () {
        var _this = this;
        this.appComponent.startLoading();
        this.nurseryManager.getNurseries(null, 15, this.currentPage).pipe(finalize(function () { return _this.appComponent.stopLoading(); })).subscribe(function (_a) {
            var listInfo = _a[0], nurseries = _a[1];
            _this.listInfo = listInfo;
            _this.nurseries = nurseries;
            _this.setTable();
        });
    };
    NurseryListComponent.prototype.onSyncProducts = function () {
        var _this = this;
        this.appComponent.startLoading();
        this.photosphereManager.syncProducts()
            .pipe(finalize(function () { return _this.appComponent.stopLoading(); }))
            .subscribe();
    };
    NurseryListComponent.prototype.onSearchConfirmed = function (searchText) {
        this.searchText = searchText;
        this.currentPage = 0;
        this.getNurseries();
    };
    NurseryListComponent.prototype.onPageChanged = function (num) {
        this.currentPage = num;
        this.getNurseries();
    };
    NurseryListComponent.prototype.onHeaderClick = function (sort) {
        this.sortField = sort[0];
        this.sortAsc = sort[1];
        this.getNurseries();
    };
    NurseryListComponent.prototype.setTable = function () {
        var _this = this;
        var headers = {
            "name": new TableInfoHeader("NURSERY_LIST_COMPONENT_HEADER_NAME", false, this.sortAsc === true, this.sortField === "name"),
            "address": new TableInfoHeader("NURSERY_LIST_COMPONENT_HEADER_ADDRESS", false, this.sortAsc === true, this.sortField === "address"),
            "actions": new TableInfoHeader("NURSERY_LIST_COMPONENT_HEADER_ACTIONS", false, false, false)
        };
        var items = [];
        for (var _i = 0, _a = this.nurseries; _i < _a.length; _i++) {
            var nursery = _a[_i];
            items.push({
                "name": (nursery.name) ? nursery.name : "",
                "address": (nursery.address) ? nursery.address : ""
            });
        }
        var buttons = [];
        buttons.push(new ButtonsModel("NURSERY_COMPONENT_TABLE_BUTTON_VIEW", TABLELIST_BUTTON_COLOR_4, TABLELIST_BUTTON_ICON_CLASS_VIEW, function (item) {
            _this.onViewDetailClick(item);
        }));
        buttons.push(new ButtonsModel("NURSERY_LIST_COMPONENT_TABLE_BUTTON_CLONE", TABLELIST_BUTTON_COLOR_5, TABLELIST_BUTTON_ICON_CLASS_CLONE, function (item) {
            _this.onCloneClick(item);
        }));
        buttons.push(new ButtonsModel("PROMOTION_LIST_COMPONENT_TABLE_BUTTON_DELETE", TABLELIST_BUTTON_COLOR_8, TABLELIST_BUTTON_ICON_CLASS_DELETE, function (item) {
            _this.onDeleteClick(item);
        }));
        this.tableInfo = new TableInfo(headers, items, TABLELIST_ITEMS_PER_PAGE, buttons);
    };
    NurseryListComponent.prototype.subscribeGenericServices = function () {
        var _this = this;
        this.onNewCalledSubscription = this.genericService.onNewCalled.subscribe(function () {
            _this.goToRouteByName(PRIVATE_NURSERY_ADD_ROUTE);
        });
    };
    return NurseryListComponent;
}(BaseComponent));
export { NurseryListComponent };
